import { ThemeProvider, createTheme, CssBaseline, ThemeOptions } from "@mui/material";
import {FavoritesProvider} from 'assets/favorites';

import ProofStatus from "components/ProofStatus";

import Navigation from "Navigation"

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#5198fc',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#aa00ff',
    },
    text: {
      primary_bold: 'rgba(0, 0, 0, 0.75)'
    },
    background: {
      default: '#f7f9fb',
    },
  },
  typography: {
    fontFamily: 'Helvetica, Roboto, sans-serif',
  },
};

function App() {

  const theme = createTheme(themeOptions);

  return (
    <ThemeProvider theme={theme}>
      <ProofStatus/>
      <FavoritesProvider>
        <CssBaseline/>
        <Navigation/>
      </FavoritesProvider>
    </ThemeProvider>  
  );
}

export default App;
